import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=9cc80860"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cc80860')) {
      api.createRecord('9cc80860', component.options)
    } else {
      api.reload('9cc80860', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=9cc80860", function () {
      api.rerender('9cc80860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Protein/rmcPurchaseQty/detail.vue"
export default component.exports